import React from "react";
import { makeStyles, Button, Typography } from "@material-ui/core";

import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import LoadingOverlay from '@configuratorware/configurator-frontendgui/Framework/Components/LoadingOverlay';
import Portal from "@material-ui/core/Portal";

const useStyles = makeStyles(
  (theme) => ({
    root: {
      border: `1px solid ${theme.palette.primary.light}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(2),
      boxSizing: "border-box",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      alignItems: "center",
      gap: theme.spacing(2),
      marginTop: theme.spacing(1),
      [theme.breakpoints.up('sm')]: {
        marginTop: theme.spacing(2),
      },
    },
    amount: {
      flex: "0 0 auto",
    },
    priceWrapper: {
      flex: "1",
      textAlign: "right",
    },

    price: {
      fontWeight: 700,
      fontSize: "1.125rem",
    },

    vatInfo: {
      fontSize: ".75rem",
    },

    mainButton: {
      flex: "0 1 100%",
    },
  }),
  { name: "CustomAmountPrice" }
);

const CustomAmountPrice = (props) => {
  const { amount, priceFormatted, showReceiveOfferForm } = props;
  const classes = useStyles({});

  const handleOnClick = () => {
    // props.openPriceOverview();
    // instead of opening the price overview dialog, directly add to basket
    props.onAddToBasket();
  };

  return (
    <>
      <div className={classes.root}>
        <Typography className={classes.amount}>
          {amount} {t("amountPrice.pieces")}
        </Typography>
        <div className={classes.priceWrapper}>
          <Typography className={classes.price}>{priceFormatted}</Typography>
          <Typography className={classes.vatInfo}>
            {t("amountPrice.vatNotice")}
          </Typography>
        </div>
        <Button
          className={classes.mainButton}
          variant="contained"
          onClick={handleOnClick}
          color="primary"
          fullWidth
        >
          {t("amountPrice.intoCart")}
        </Button>
      </div>
      {props.addToCartPopUpLoader && (
        <Portal>
          <LoadingOverlay show={true} />
        </Portal>
      )}
    </>
  );
};

export default CustomAmountPrice;
